import DoctornowImage from '@/components/atom/images/DoctornowImage';
import styled, { css } from 'styled-components';

interface CategoryProps {
  name: string;
  description?: string;
  imageUrl: string;
  onClick: () => void;
}

const MedicalCategory = ({ name, description, imageUrl, onClick }: CategoryProps) => {
  return (
    <CategoryWrapper onClick={onClick}>
      <CategoryInfo>
        <p>{name}</p>
        <span>{description}</span>
      </CategoryInfo>
      <CategoryImageWrapper>
        <DoctornowImage src={imageUrl} width={38} height={38} loading='eager' alt={name} />
      </CategoryImageWrapper>
    </CategoryWrapper>
  );
};

export default MedicalCategory;

const CategoryWrapper = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => (theme.client.isMobile ? '20px 24px 24px' : '20px 12px')};
`;

const CategoryInfo = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    & > p {
      ${theme.typography.UI18SB}
      color: ${theme.color.gray900};
    }
    & > span {
      ${theme.typography.UI16R}
      color: ${theme.color.gray500};
      margin-top: 2px;
    }
  `}
`;

const CategoryImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  margin-left: 20px;
`;
